module.exports = __webpack_public_path__ + "img/avatar2.e625a9bf.png";